import styled from '@emotion/styled';
import { colors, Stack, Typography } from '@ui-components/neo.tax';

export const LockContainer = styled(Stack)({
  backgroundColor: colors.gray[300],
  borderRadius: 6,
  color: colors.gray[700],
  minHeight: 58,
  padding: '0.75rem 1rem',
  width: '100%',
});

export const LockTextContainer = styled(Stack)({
  height: '100%',
  width: '100%',
});

export const StyledTitle = styled(Typography)({
  color: colors.gray[800],
});

export const StyledSubtitle = styled(Typography)({
  color: colors.gray[700],
});
